import layerManager from '../layer.manager';
import {
  userActionInterceptor,
  staticIdDecorator,
} from '../socketIO/user.action.interceptor';
import store from '../../store/index';
import eventBus from '../../services/eventBus.service';
@staticIdDecorator('RedPacketsProxy')
class RedPacketsProxy {
  opened = false;
  promotionId = '';
  redPacketsTypeId = 0;
  typeId = 0;
  @userActionInterceptor({ methodName: 'openRedPacketOrderLayer' })
  showRedPackets({
    isRemote = true,
    promotionId = '', // 红包id
    seriesId = 0,
    redPacketsTypeId = 0,
    dealerId = 0,
    typeId = 0,
  }) {
    console.log({
      seriesId,
      dealerId,
    });
    this.opened = true;
    if (isRemote) {
      layerManager.toast({ message: '客户正在打开红包弹层！' }, 1500);
    } else {
      layerManager.toast({ message: '已成功发给客户' }, 1500);
    }
    this.promotionId = promotionId;
    this.redPacketsTypeId = redPacketsTypeId;
    this.typeId = typeId;
  }
  @userActionInterceptor({ methodName: 'showRedPackets' })
  order({ isRemote = true }) {
    console.log('showRedPackets', isRemote);
  }
  openRedPacketOrderLayer({
    promotionId = '', // 红包id
    seriesId = 0,
    redPacketsTypeId = 0,
    dealerId = 0,
    typeId = 0,
  }) {
    const vrSalesInfo = store.state.sales.vrSalesInfo;
    layerManager.openRedPacket({
      propsData: {
        elementId: '2|1211004|897|24487|205363|304318',
        dealerId: Number(dealerId),
        seriesId: Number(seriesId),
        promotionId,
        redPacketsTypeId,
        channelId: vrSalesInfo.channelId || '',
        salesId: vrSalesInfo.salesId || 0,
        ext: { promotionId, typeId: redPacketsTypeId },
      },
    });
    this.promotionId = promotionId;
    this.redPacketsTypeId = redPacketsTypeId;
    this.typeId = typeId;
  }
  @userActionInterceptor()
  close() {
    this.opened = false;
  }
  @userActionInterceptor()
  successResult() {
    if (this.promotionId === '') {
      return;
    }
    eventBus.$emit('redPackcollect', {
      promotionId: this.promotionId,
      redPacketsTypeId: this.redPacketsTypeId,
      typeId: this.typeId,
    });
  }
}
const redPacketsProxy = new RedPacketsProxy();
export default redPacketsProxy;
